/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConnectedApplicationPlatform {
    Android = 'ANDROID',
    Ios = 'IOS',
    Web = 'WEB'
}

export function ConnectedApplicationPlatformFromJSON(json: any): ConnectedApplicationPlatform {
    return ConnectedApplicationPlatformFromJSONTyped(json, false);
}

export function ConnectedApplicationPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectedApplicationPlatform {
    return json as ConnectedApplicationPlatform;
}

export function ConnectedApplicationPlatformToJSON(value?: ConnectedApplicationPlatform | null): any {
    return value as any;
}

